import React from "react";

import { ForgotPasswordForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const ForgotPasswordPage = ({ history }) => {
  return (
    <div className="ForgotPasswordPage">
      <ForgotPasswordForm history={history} />
    </div>
  );
};

export default withUnAuth(AuthContainer(ForgotPasswordPage));
